import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PasswordModal from './PasswordModal';
import './CatechistProfile.css';

const CatechistProfile = () => {
  const navigate = useNavigate();
  const catechistFullName = localStorage.getItem('catechistFullName') || 'Giáo lý viên';
  const username = localStorage.getItem('username');
  const catechistHolyName = localStorage.getItem('catechistHolyName') || '';
  const catechistClassName = localStorage.getItem('catechistClassName') || ''; // <<< THÊM DÒNG NÀY: Lấy lớp học

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  return (
    <div className="catechist-profile">
      <div className="profile-header">
        <h2>Thông tin giáo lý viên</h2>
        <button onClick={() => navigate(-1)} className="back-button">
          Quay lại
        </button>
      </div>

      <div className="profile-content">
        <div className="info-section">
          <h3>Thông tin cá nhân</h3>
          {catechistHolyName && (
            <div className="info-item">
              <label>Tên Thánh:</label>
              <span>{catechistHolyName}</span>
            </div>
          )}
          <div className="info-item">
            <label>Họ và tên:</label>
            <span>{catechistFullName}</span>
          </div>
          {/* Hiển thị lớp học nếu có */}
          {catechistClassName && ( // <<< THÊM KHỐI NÀY
            <div className="info-item">
              <label>Đứng lớp:</label>
              <span>{catechistClassName}</span>
            </div>
          )}
          {username && (
            <div className="info-item">
              <label>Tên đăng nhập:</label>
              <span>{username}</span>
            </div>
          )}
        </div>

        <div className="password-section">
          <h3>Mật khẩu</h3>
          <button
            onClick={() => setIsPasswordModalOpen(true)}
            className="change-password-button"
          >
            Đổi mật khẩu
          </button>
        </div>
      </div>

      <PasswordModal
        isOpen={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
        username={username}
      />
    </div>
  );
};

export default CatechistProfile;